var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0717 6.07031C7.26334 6.4943 5.01734 8.81376 4.67964 11.7949L4.33476 14.8393C4.24906 15.5958 3.94246 16.3077 3.45549 16.8809C2.42209 18.0972 3.26081 20.0008 4.83014 20.0008H17.1699C18.7392 20.0008 19.5779 18.0972 18.5445 16.8809C18.0575 16.3077 17.7509 15.5958 17.6652 14.8393L17.4373 12.8276M14 22.0008C13.5633 23.166 12.385 24.0008 11 24.0008C9.61497 24.0008 8.43668 23.166 8 22.0008",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.436 6.20972C17.1738 6.20972 16.9342 6.41527 16.9458 6.6772C16.9582 6.95775 16.7344 7.18911 16.4566 7.18911H15.4772C15.2067 7.18911 14.9875 6.96987 14.9875 6.69941C14.9875 6.42895 14.7683 6.20972 14.4978 6.20972H13.5184C13.1308 6.20972 12.7582 6.27406 12.4106 6.39267C11.0611 6.85327 10.0906 8.13208 10.0906 9.63757C10.0906 11.5307 11.6253 13.0654 13.5184 13.0654C13.6335 13.0654 16.0395 13.0812 16.7502 10.6515C17.0047 9.78181 17.7477 9.14788 18.6539 9.14788H20.668C21.2089 9.14788 21.6473 8.70936 21.6473 8.16849V7.18911C21.6473 6.64821 21.2089 6.20972 20.668 6.20972H17.436Z",
    stroke: "#B18535",
    strokeWidth: 0.99439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5185 10.3555C13.1228 10.3555 12.8007 10.0334 12.8007 9.63767C12.8007 9.24196 13.1228 8.91987 13.5185 8.91987C13.9142 8.91987 14.2363 9.24196 14.2363 9.63767C14.2363 10.0334 13.9142 10.3555 13.5185 10.3555Z",
    stroke: "#B18535",
    strokeWidth: 0.99439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.871 2.28966V3.26904",
    stroke: "#B18535",
    strokeWidth: 0.99439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7947 3.55699L14.4872 4.24951",
    stroke: "#B18535",
    strokeWidth: 0.99439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9489 3.55601L17.2563 4.24854",
    stroke: "#B18535",
    strokeWidth: 0.99439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.70a7f8412f675e99a20037dda4438a93.svg";
export { ForwardRef as ReactComponent };